import { getStrapiMedia } from "@/app/[lang]/utils/api-helpers";

type VideoComponentProps = {
    data: any,
    hidden?: boolean,
}

export const Video:React.FC<VideoComponentProps> = (props) => {
    const { data, hidden } = props;
    const src = getStrapiMedia(data.attributes.url)

    if ( !src || !!hidden) {
        return null
    }


    return (
        <video controls width="100%">
            <source src={src} type={ data.attributes.mime} />
            Your browser does not support the video tag.
        </video>
    )
}
